import { render, staticRenderFns } from "./NeedArticles.vue?vue&type=template&id=77efd772&scoped=true&"
import script from "./NeedArticles.vue?vue&type=script&lang=js&"
export * from "./NeedArticles.vue?vue&type=script&lang=js&"
import style0 from "./NeedArticles.vue?vue&type=style&index=0&id=77efd772&prod&lang=css&"
import style1 from "./NeedArticles.vue?vue&type=style&index=1&id=77efd772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77efd772",
  null
  
)

export default component.exports